import { ScrapbookFile } from '@/api/scrapbook-data';
import ContentPreviewWraper from './ContentPreviewWraper';
import AnalyticsBuilderReportContent from '@/components/analytics-builder/AnalyticsBuilderReportContent';

interface AnalyticsBuilderPreviewProps {
  content: ScrapbookFile | null;
  onClose: () => void;
}
const AnalyticsBuilderPreview = ({ content, onClose }: AnalyticsBuilderPreviewProps) => {
  if (!content) return null;

  return (
    <ContentPreviewWraper
      content={content}
      onClose={onClose}
      title="Analytics Builder"
      subTitle={content?.content?.displayName}
      className="!max-h-[92vh] [&_.content-wrapper]:!p-0 [&_.content-wrapper>div]:!px-0"
    >
      <AnalyticsBuilderReportContent
        reportData={content.content}
        onExport={() => {}}
        hideSaveToScrapbookButton
        hideDownloadButton
        className="!h-full"
      />
    </ContentPreviewWraper>
  );
};

export default AnalyticsBuilderPreview;
